import React, { useState } from "react";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PdfPreview from "../../../Common/PDFPreview";
import { formatDate } from "../../../Common/FormatFunctions/FormatDate";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";

const CheckRTGSReport = ({ Slip_No, disabledFeild }) => {
    const API_URL = process.env.REACT_APP_API;
    const apikey = process.env.REACT_APP_API_URL;
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
    const newCompanyName = sessionStorage.getItem("newCompanyName")
    const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")

    const [pdfPreview, setPdfPreview] = useState(null);
    const [apiData, setAPIData] = useState([]);
    const [isBillToShipToSame, setIsBillToShipToSame] = useState(true);

    const fetchData = async () => {
        try {
            // Add basic validation
            if (!API_URL) {
                console.error("API_URL is not defined");
                alert("Configuration error: API URL not found");
                return;
            }

            const response = await fetch(
                `${API_URL}/getRTGSReport?Company_Code=${companyCode}&Year_Code=${Year_Code}&Slip_No=${Slip_No}`
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();

            // Add data validation
            if (!data.all_data || !data.all_data[0]) {
                throw new Error("No data received from server");
            }

            setAPIData(data.all_data);
            generatePdf(data.all_data);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert("Error: " + error.message);
        }
    };

    const generatePdf = (data) => {
        // Add validation
        if (!data || !data[0]) {
            console.error("No data to generate PDF");
            return;
        }

        const allData = data[0];

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        pdf.setFont("Helvetica");

        /* A/C PAYEE */
        pdf.setFontSize(12);
        pdf.text("A/C Payee", 120, 3);

        /* PAYEE NAME - with null check */
        pdf.setFont("Helvetica", "bold");
        pdf.setFontSize(12);

        // Handle undefined PartyName
        const partyName = allData.PartyName ? allData.PartyName.trim() : "Unknown";
        pdf.text(
            `Yourself For RTGS ${partyName}`,
            25,
            14,
            { maxWidth: 140 }
        );

        /* AMOUNT IN WORDS - with null check */
        const amount = allData.Amount || 0;
        const amountWords = ConvertNumberToWord(amount);
        pdf.setFont("Helvetica", "normal");
        pdf.setFontSize(12);
        pdf.text(
            amountWords,
            30,
            22,
            { maxWidth: 150 }
        );

        /* AMOUNT IN NUMBERS - with proper formatting */
        pdf.setFont("Helvetica", "bold");
        pdf.setFontSize(12);

        // Format amount to handle both string and number
        const formattedAmount = typeof amount === 'number'
            ? amount.toFixed(2)
            : parseFloat(amount).toFixed(2);

        pdf.text(
            formattedAmount,
            165,
            30,
            { maxWidth: 150 }
        );

        /* DATE - with error handling */
        const splitDateDigits = (dateStr) => {
            if (!dateStr) return [];
            try {
                const [dd, mm, yyyy] = dateStr.split("/");
                return [...dd, ...mm, ...yyyy];
            } catch (e) {
                console.error("Date parsing error:", e);
                return [];
            }
        };

        const dateDigits = splitDateDigits(allData.Doc_Date);
        const dateBoxStartX = 160;
        const dateBoxY = 3;
        const boxGap = 5;

        pdf.setFont("Helvetica", "bold");
        pdf.setFontSize(12);

        dateDigits.forEach((digit, index) => {
            pdf.text(
                digit,
                dateBoxStartX + index * boxGap,
                dateBoxY,
                { align: "center" }
            );
        });

        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfPreview(pdfUrl);
    };

    return (
        <div id="pdf-content">
            {pdfPreview && (
                <PdfPreview
                    pdfData={pdfPreview}
                    apiData={apiData[0]}
                    label={"UTR"}
                />
            )}
            <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Cheque Print"} />
        </div>
    );
};

export default CheckRTGSReport;



// import React, { useState } from "react";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import PdfPreview from "../../../Common/PDFPreview";
// import PrintButton from "../../../Common/Buttons/PrintPDF";
// import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";

// const CheckRTGSReport = ({ Slip_No, disabledFeild }) => {
//     const API_URL = process.env.REACT_APP_API;
//     const companyCode = sessionStorage.getItem("Company_Code");
//     const Year_Code = sessionStorage.getItem("Year_Code");

//     const [pdfPreview, setPdfPreview] = useState(null);
//     const [apiData, setAPIData] = useState([]);

//     const fetchData = async () => {
//         try {
//             if (!API_URL) {
//                 alert("Configuration error: API URL not found");
//                 return;
//             }
//             const response = await fetch(
//                 `${API_URL}/getRTGSReport?Company_Code=${companyCode}&Year_Code=${Year_Code}&Slip_No=${Slip_No}`
//             );
//             if (!response.ok) throw new Error("Network response was not ok");
//             const data = await response.json();
//             if (!data.all_data || !data.all_data[0]) throw new Error("No data received from server");

//             setAPIData(data.all_data);
//             generatePdf(data.all_data);
//         } catch (error) {
//             console.error("Error fetching data:", error);
//             alert("Error: " + error.message);
//         }
//     };

//     const generatePdf = (data) => {
//         if (!data || !data[0]) return;
//         const allData = data[0];

//         // ── KEY FIX 1: Use exact cheque dimensions as page size.
//         // Standard Indian cheque = 210mm wide x 90mm tall.
//         // When PDF page size == cheque size, there is nothing to scale —
//         // every printer renders it at 1:1 regardless of paper loaded.
//         const CHEQUE_WIDTH  = 210; // mm
//         const CHEQUE_HEIGHT = 90;  // mm  ← change to match your actual cheque

//         const pdf = new jsPDF({
//             orientation: "landscape",
//             unit: "mm",
//             format: [CHEQUE_HEIGHT, CHEQUE_WIDTH], // jsPDF landscape: [height, width]
//             compress: true,
//         });

//         pdf.setFont("Helvetica");

//         /* A/C PAYEE — original coordinates unchanged */
//         pdf.setFontSize(12);
//         pdf.text("A/C Payee", 15, 8);

//         /* PAYEE NAME — original coordinates unchanged */
//         pdf.setFont("Helvetica", "bold");
//         pdf.setFontSize(12);
//         const partyName = allData.PartyName ? allData.PartyName.trim() : "Unknown";
//         pdf.text(`Yourself For RTGS ${partyName}`, 25, 14, { maxWidth: 140 });

//         /* AMOUNT IN WORDS — original coordinates unchanged */
//         const amount = allData.Amount || 0;
//         const amountWords = ConvertNumberToWord(amount);
//         pdf.setFont("Helvetica", "normal");
//         pdf.setFontSize(12);
//         pdf.text(amountWords, 25, 22, { maxWidth: 150 });

//         /* AMOUNT IN NUMBERS — original coordinates unchanged */
//         pdf.setFont("Helvetica", "bold");
//         pdf.setFontSize(12);
//         const formattedAmount = typeof amount === "number"
//             ? amount.toFixed(2)
//             : parseFloat(amount).toFixed(2);
//         pdf.text(formattedAmount, 165, 30, { maxWidth: 150 });

//         /* DATE — original coordinates unchanged */
//         const splitDateDigits = (dateStr) => {
//             if (!dateStr) return [];
//             try {
//                 const [dd, mm, yyyy] = dateStr.split("/");
//                 return [...dd, ...mm, ...yyyy];
//             } catch (e) {
//                 return [];
//             }
//         };
//         const dateDigits   = splitDateDigits(allData.Doc_Date);
//         const dateBoxStartX = 160;
//         const dateBoxY      = 3;
//         const boxGap        = 5;

//         pdf.setFont("Helvetica", "normal");
//         pdf.setFontSize(12);
//         dateDigits.forEach((digit, index) => {
//             pdf.text(digit, dateBoxStartX + index * boxGap, dateBoxY, { align: "center" });
//         });

//         // ── KEY FIX 2: Attach print CSS to the blob URL so the browser
//         // never adds margins or scales the page when printing.
//         const pdfBlob = pdf.output("blob");
//         const pdfUrl  = URL.createObjectURL(pdfBlob);
//         setPdfPreview(pdfUrl);
//     };

//     return (
//         <div id="pdf-content">
//             {pdfPreview && (
//                 <>
//                     {/* KEY FIX 3: Hidden iframe for printing.
//                         The iframe renders the PDF at 100% scale with
//                         zero margins — bypasses browser print scaling. */}
//                     <iframe
//                         id="cheque-print-frame"
//                         src={pdfPreview}
//                         style={{ display: "none" }}
//                         title="Cheque Print"
//                     />
//                     <PdfPreview
//                         pdfData={pdfPreview}
//                         apiData={apiData[0]}
//                         label={"UTR"}
//                     />
//                 </>
//             )}
//             <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Cheque Print"} />
//         </div>
//     );
// };

// export default CheckRTGSReport;